<div [internalInnerHtml]="content.description" [userEventSource]="userEventSource"></div>
<button type="button" class="button form__button button--full-width button--cta" [airButtonLoading]="isLoading" (click)="onSubmit($event)">
  <span>{{ "general.label.confirm" | translate }}</span>
</button>
